var React = require('react');

function Code (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"18","height":"18","x":"3","y":"3","className":"primary","rx":"2","key":0}),React.createElement("path",{"className":"secondary","d":"M8.7 13.3a1 1 0 0 1-1.4 1.4l-2-2a1 1 0 0 1 0-1.4l2-2a1 1 0 1 1 1.4 1.4L7.42 12l1.3 1.3zm6.6 0l1.29-1.3-1.3-1.3a1 1 0 1 1 1.42-1.4l2 2a1 1 0 0 1 0 1.4l-2 2a1 1 0 0 1-1.42-1.4zm-3.32 3.9a1 1 0 0 1-1.96-.4l2-10a1 1 0 0 1 1.96.4l-2 10z","key":1})]);
}

Code.defaultProps = {"viewBox":"0 0 24 24","className":"icon-code"};

module.exports = Code;

Code.default = Code;
